module.exports = __webpack_public_path__ + "216e494698efb1a1740338c24308e589.jpg";